import { Layout } from '@/components/Layout';

// Placeholder staff-only surface (issue #237). Rendering is gated by
// the is_admin claim in App.tsx; the real enforcement is the API's
// admin middleware. Panel features land in follow-up issues under the
// same milestone.
export function AdminPage() {
  return (
    <Layout>
      <div className="mx-auto max-w-3xl px-4 py-8" data-testid="admin-page">
        <h1 className="text-2xl font-bold text-wolisho-brown">Admin</h1>
        <p className="mt-2 text-gray-600">
          Staff-only tools will appear here.
        </p>
      </div>
    </Layout>
  );
}
